<template>
<!-- 预约到店 -->
<div class="viewContainer">
  <div class="main_container">
    <div class="fuji" @click="show2 = !show2">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">数据概述</span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
    <div class="peonum" v-show="show2">
      <div>
        <p class="peonumInfo">
          <span>今日预约：</span>
          <span>{{userInfo1[0].DailyReservationCount}}人</span>
        </p>
        <p class="peonumInfo">
          <span>今日到店：</span>
          <span>{{userInfo1[0].DailyInshopCount}}人</span>
        </p>
      </div>
      <div>
        <p class="peonumInfo">
          <span>本周预约：</span>
          <span>{{userInfo1[0].WeeklyReservationCount}}人</span>
        </p>
        <p class="peonumInfo">
          <span>本周到店：</span>
          <span>{{userInfo1[0].WeeklyInshopCount}}人</span>
        </p>
      </div>
      <div>
        <p class="peonumInfo">
          <span>本月预约：</span>
          <span>{{userInfo1[0].MonthlyReservationCount}}人</span>
        </p>
        <p class="peonumInfo">
          <span>本月到店：</span>
          <span>{{userInfo1[0].MonthlyInshopCount}}人</span>
        </p>
      </div>
      <div>
        <p class="peonumInfo">
          <span>本年预约：</span>
          <span>{{userInfo1[0].YearlyReservationCount}}人</span>
        </p>
        <p class="peonumInfo">
          <span>本年到店：</span>
          <span>{{userInfo1[0].YearlyInshopCount}}人</span>
        </p>
      </div>
      <div style="border:none">
        <p class="peonumInfo">
          <span>全部预约：</span>
          <span>{{userInfo1[0].TotallyReservationCount}}人</span>
        </p>
        <p class="peonumInfo">
          <span>全部到店：</span>
          <span>{{userInfo1[0].TotallyInshopCount}}人</span>
        </p>
      </div>
    </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
    <el-form :model="formInline" :inline="true" style="width:100%;display:flex;margin:10px 0 0 20px;">
      <!-- <el-form-item style="display:flex;width:100%" label="客户姓名：">
        <el-input placeholder="请输入客户姓名" v-model="cName"  maxlength="20"></el-input>
      </el-form-item> -->
      <el-form-item style="display:flex;width:80%" label="客户电话：">
        <el-input placeholder="请输入客户电话" v-model="cPhone" maxlength="11" style="width:90%"/>
      </el-form-item>
      <el-form-item style="display:flex;width:80%" label="是否到店：">
        <el-select v-model="isIn" style="width:90%">
          <el-option v-for="(item,index) in arr" :key="index" :value="item.Id" :label="item.Name"/>
        </el-select>
      </el-form-item>
      <el-form-item style="display:flex;width:80%"> <el-button type="danger" @click="findshop()">查 询</el-button> </el-form-item>
    </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!-- 表格 -->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">预约到店</p>
    </section>
    <div class="table_container">
      <el-table :data="userInfo" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> {{scope.$index + 1}} </template>
        </el-table-column>
        <el-table-column prop="CPhone" label="客户电话" align="center">
          <template scope="scope">{{scope.row.CPhone}}</template>
        </el-table-column>
        <el-table-column prop="CTime" align="center" label="预约时间">
          <template scope="scope">{{scope.row.CTime}}</template>
        </el-table-column>
        <el-table-column prop="GoodsName" label="店铺" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.BbName">{{ scope.row.BbName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="GoodsName" label="关注商品" align="center">
            <template scope="scope">{{scope.row.GoodsName}}</template>
        </el-table-column>
        <el-table-column prop="Remark" label="预约信息" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.Remark">{{ scope.row.Remark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="IsInShop" label="是否已到店" align="center" width="130px">
          <template scope="scope">{{scope.row.IsInShop}}</template>
        </el-table-column>
        <el-table-column prop="InStoreTime" label="到店时间" align="center" width="120px">
          <template scope="scope">{{scope.row.InStoreTime}}</template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right" align="center">
          <template scope="scope">
            <!-- <a href="javascript:;" @click="showdoalo(scope)" class="ahref">跟进记录</a>
            <a href="javascript:;" v-show="scope.row.IsIn == 0" class="ahref" @click="editinfo(scope)">到店</a> -->
            <span class="handle" @click="showdoalo(scope)" v-show="!is_content(scope.row.Remark)">
              <i class="el-icon-s-order"></i> 跟进记录
            </span>
            <span class="handle" @click="editinfo(scope)" v-show="scope.row.IsIn!=1 && !is_content(scope.row.Remark)">
              <i class="el-icon-circle-check"></i> 到店
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>

  <!-- 跟进记录 -->
  <el-dialog title="跟进记录" :center="true" :visible.sync="dialogVisibledelete" :before-close="handleClose" width="50%">
    <el-table :data="followList" stripe border style>
      <el-table-column prop="FollowerName1" label="跟进人" width="200px" align="center"></el-table-column>
      <el-table-column prop="CTime" label="跟进时间" width="200px" align="center"></el-table-column>
      <el-table-column prop="Remark" align="center" label="跟进内容"></el-table-column>
    </el-table>
    <div style="overflow:hidden">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange1"
      :page-size="5" :current-page="pageIndex1" :total="total1" style="float:right;margin:10px 0;"/>
    </div>
    <div style="height:1px;background:#eee;margin-top:30px"></div>
    <div class="addgjjl">添加跟进记录</div>
    <el-input type="textarea" v-model="remark" placeholder="请输入跟进记录（200字以内）"
    :autosize="{ minRows: 2, maxRows: 6}" maxlength="200" show-word-limit style="margin-top:20px;"/>
    <div style="text-align:center; margin-top: 20px;">
      <el-button type="danger" @click="followUp()" class="dialog-footer">保 存</el-button>
    </div>
  </el-dialog>
  <el-dialog title="确认" :center="true" :visible.sync="dialogVisibledelete1" width="30%">
    <span>
      <div style="text-align:center;margin-top:50px;margin-bottom:50px">是否确认客户已到店咨询？</div>
    </span>
    <span slot="footer" style="text-align:center" class="dialog-footer">
      <div style="text-align:center">
        <el-button @click="dialogVisibledelete1 = false">取 消</el-button>
        <el-button type="danger" @click="makesure()">确认</el-button>
      </div>
    </span>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { SelectBBReservationList, SelectBBShopFollowUpList, InsertBBShopFollowUp, EditBBShopIsOpenAndIsCertificate} from "../../api/api";
export default {
  name: "appointment",
  mixins: [alertTrends],
  data() {
    return {
      show2: false, // 数据概述
      show3:true, // 搜索/查询
      shopCount:[],
      userInfo1:[{
        DailyReservationCount:0,
        DailyInshopCount:0,
        WeeklyReservationCount:0,
        WeeklyInshopCount:0,
        MonthlyReservationCount:0,
        MonthlyInshopCount:0,
        YearlyReservationCount:0,
        YearlyInshopCount:0,
         TotallyReservationCount:0,
        TotallyInshopCount:0,
      }],
      followList:[],
      followId:"",
      userInfo:[],
      cName:"",
      cPhone:"",
      remark:"",
      isIn:-1,
      formInline: {},
      arrId: 1,
      dialogVisibledelete: false,
      dialogVisibledelete1: false,
      pageIndex: 1,
      pageIndex1:1,
      total: 0,
      total1:0,
      goodListInfo: [],
      arr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 0,
          Name: "否"
        }
      ]
    };
  },
  methods: {
    // 处理列表备注字段中 是否存在 取消预约 四个字
    is_content(s){
      if (typeof s === 'string') {
        return s.search('取消预约')>-1;
      } else {
        return false;
      }
    },
    // 重置
    fnReset() {
      this.cName = "";
      this.cPhone = "";
      this.isIn = -1;
      // this.getInfolist()
    },
    // 查询
    findshop(){
      this.getInfolist()
      // this.getInfolist2()
    },
    handleClose(){
      this.dialogVisibledelete = false
      this.remark = ""
    },
    makesure(){
         var obj = {
           bbId:this.followId,
           userId:localStorage.Id,
           operType:4
         }
       EditBBShopIsOpenAndIsCertificate(obj).then(data=>{
          this.dialogVisibledelete1 =  false
         if(data.ResultCode == 1){
           this. getInfolist()
          //  this.getInfolist2()
          this.showAlert('确认到店成功', 'success');
         }
       })  
    },
    //新增跟进
    followUp(){
      var obj = {
        operType : 2,
        id:this.followId,
        remark:this.remark,
        userId:localStorage.Id
      }
      InsertBBShopFollowUp(obj).then(data=>{
        if(data.ResultCode == 1){
          // this.dialogVisibledelete = false
          this.remark = "";
          this.showAlert('保存成功', 'success');
          this.getfollowlist();
        }
      })
    },
    //查询预约到店列表
    getInfolist(){
      var obj = {
        // userId:1443,
        userId:localStorage.Id,
        cName:this.cName,
        cPhone:this.cPhone,
        isIn:this.isIn,
        pageIndex:this.pageIndex,
        pageSize:10
      }
      SelectBBReservationList(obj).then(data=>{
        console.log(data,"预约到店")
        if(data.ResultCode == 1){
          this.userInfo = data.ResultObj
          this.total = data.RowsCount
          this.shopCount = data.ResultMsg.split("|")
            this.userInfo1 = [{
              DailyReservationCount: this.shopCount[0],
              DailyInshopCount:this.shopCount[1],
              WeeklyReservationCount:this.shopCount[2],
              WeeklyInshopCount:this.shopCount[3],
              MonthlyReservationCount:this.shopCount[4],
              MonthlyInshopCount:this.shopCount[5],
              YearlyReservationCount:this.shopCount[6],
              YearlyInshopCount:this.shopCount[7],
              TotallyReservationCount:this.shopCount[8],
              TotallyInshopCount:this.shopCount[9],
            }]
        }else{
          this.userInfo = []
        }
      })
    },
    //     getInfolist2(){
    //     var obj = {
    //       userId:localStorage.Id,
    //       cName:"",
    //       cPhone:"",
    //       isIn:-1,
    //       pageIndex:1,
    //       pageSize:10
    //     }
    //     SelectBBReservationList(obj).then(data=>{
    //       console.log(data,"预约到店")
    //       if(data.ResultCode == 1){
    //         this.userInfo1 = data.ResultObj
    //         // this.total = data.RowsCount
    //       }
    //     })
    // },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInfolist();
    },
    handleCurrentChange1(val){
      this.pageIndex1 = val;
      this.getfollowlist();
    },
    //查询预约跟进列表
    getfollowlist(){
      var obj = {
        operType:2,
        Id:this.followId,
        pageIndex:this.pageIndex1,
        pageSize:5
      }
      SelectBBShopFollowUpList(obj).then(data=>{
        if(data.ResultCode == 1){
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        }else if(data.ResultCode == 4){
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        }
      })
    },
    showdoalo(scope) {
      this.pageIndex1 =1;
      this.followId = scope.row.Id;
      this.dialogVisibledelete = true;
      this.getfollowlist();
    },
    editinfo(scope) {
      this.followId = scope.row.Id;
      // this.dialogVisibledelete1 = true;
      this.$swal({
        type:'warning',
        text: "是否确认客户已到店咨询？",
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((res) => {
        if(res.value){
          this.makesure();
        }
      })
    }
  },
  mounted(){
    this.getInfolist();
    // this.getInfolist2();
  }
};
</script>
<style scoped>
.region {
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #eeeeee;
  padding: 0 0 20px 20px;
}
/* 添加跟进记录 */
.addgjjl {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
}
.peonum {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}
.peonum div {
  width: 25%;
  border-right: 1px solid #eee;
}
.peonumInfo {
  text-align: center;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// appointment.vue?f54ff522